import * as React from "react";
import { List, Datagrid, TextInput, DeleteButton, useListContext } from "react-admin";
import { Alert } from "@mui/material";
import { JsonField } from "../components/JsonField";
import { ProReferenceInput, PatientReferenceInput, UserReferenceInput } from "../components/RelationAutocomplete";

// Parent = personne → recherche par nom plutôt que saisie d'identifiant.
const PERSON_INPUTS = { proId: ProReferenceInput, patientId: PatientReferenceInput, userId: UserReferenceInput, authorId: UserReferenceInput };

// Liste d'une sous-ressource backend (/parent/{parentId}/enfants) : le
// dataProvider construit le chemin depuis le filtre `parentParam`
// (resourceMap.dynamicPath). Sans ce filtre on n'appelle pas le backend :
// on affiche une consigne. Pas de lecture unitaire côté backend → pas de
// fiche : le détail brut est dans le panneau dépliable de chaque ligne.
const Hint = ({ parentParam, parentLabel }) => {
  const { filterValues } = useListContext();
  if (filterValues?.[parentParam]) return null;
  return (
    <Alert severity="info" sx={{ m: 2 }}>
      Renseignez « {parentLabel} » pour afficher cette liste (ou ouvrez-la depuis la fiche parente).
    </Alert>
  );
};

const SubResourceGrid = ({ parentParam, parentLabel, children, canDelete }) => {
  const { filterValues } = useListContext();
  if (!filterValues?.[parentParam]) return <Hint parentParam={parentParam} parentLabel={parentLabel} />;
  return (
    <Datagrid rowClick={false} bulkActionButtons={false} expand={<JsonField source="__all__" />}>
      {children}
      {canDelete ? <DeleteButton mutationMode="pessimistic" /> : null}
    </Datagrid>
  );
};

export const subResourceList = ({ parentParam, parentLabel, extraFilters = [], canDelete = false, children }) => {
  const PersonInput = PERSON_INPUTS[parentParam];
  const filters = [
    PersonInput
      ? <PersonInput key={parentParam} source={parentParam} label={parentLabel.replace(/^ID\s+/i, "").replace(/^\w/, (c) => c.toUpperCase())} alwaysOn />
      : <TextInput key={parentParam} source={parentParam} label={parentLabel} alwaysOn />,
    ...extraFilters,
  ];
  const SubList = () => (
    <List
      filters={filters}
      empty={false}
      perPage={25}
    >
      <SubResourceGrid parentParam={parentParam} parentLabel={parentLabel} canDelete={canDelete}>
        {children}
      </SubResourceGrid>
    </List>
  );
  return SubList;
};
